import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState } from 'editor/src/store/design/types';

import updateDesignPagesUtil from '../../util/updateDesignPagesUtil';

const removeSpreadReducer = (state: DesignState, action: PayloadAction<number>) => {
  if (!state.designData) {
    return;
  }

  const index = action.payload;
  const [removed] = state.designData.spreads.splice(index, 1);
  updateDesignPagesUtil(state.designData, -(removed?.pages.length ?? 0));
};

export default removeSpreadReducer;
